module.exports = __webpack_public_path__ + "img/login-bg@3x.047e50d4.png";